!function (e, t) {
  if ("object" == typeof exports && "object" == typeof module) module.exports = t(require("prop-types"), require("filestack-js"), require("react"));else if ("function" == typeof define && define.amd) define(["prop-types", "filestack-js", "react"], t);else {
    var n = "object" == typeof exports ? t(require("prop-types"), require("filestack-js"), require("react")) : t(e["prop-types"], e["filestack-js"], e.react);

    for (var o in n) {
      ("object" == typeof exports ? exports : e)[o] = n[o];
    }
  }
}(window, function (e, t, n) {
  return function (e) {
    var t = {};

    function n(o) {
      if (t[o]) return t[o].exports;
      var r = t[o] = {
        i: o,
        l: !1,
        exports: {}
      };
      return e[o].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, o) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: o
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var o = Object.create(null);
      if (n.r(o), Object.defineProperty(o, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var r in e) {
        n.d(o, r, function (t) {
          return e[t];
        }.bind(null, r));
      }
      return o;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 3);
  }([function (t, n) {
    t.exports = e;
  }, function (e, n) {
    e.exports = t;
  }, function (e, t) {
    e.exports = n;
  }, function (e, t, n) {
    "use strict";

    n.r(t);
    var o = n(1),
        r = n(2),
        i = n.n(r),
        c = n(0),
        a = n.n(c);

    function u(e) {
      return (u = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function s(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {},
            o = Object.keys(n);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(n).filter(function (e) {
          return Object.getOwnPropertyDescriptor(n, e).enumerable;
        }))), o.forEach(function (t) {
          m(e, t, n[t]);
        });
      }

      return e;
    }

    function l(e, t) {
      for (var n = 0; n < t.length; n++) {
        var o = t[n];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
      }
    }

    function p(e) {
      return (p = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function f(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }

    function y(e, t) {
      return (y = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function m(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    var d = function (e) {
      function t(e) {
        var n, r, i;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), r = this, i = p(t).call(this, e), n = !i || "object" !== u(i) && "function" != typeof i ? f(r) : i, m(f(n), "onClickPick", function (e) {
          e.stopPropagation(), e.preventDefault(), n.completeAction().then(n.onFinished).catch(n.onFail);
        }), m(f(n), "onFinished", function (e) {
          var t = n.props.onSuccess;
          "function" == typeof t && e && t(e);
        }), m(f(n), "onFail", function (e) {
          var t = n.props.onError;
          "function" == typeof t ? t(e) : console.error(e);
        }), m(f(n), "completeAction", function () {
          var e = n.state,
              t = e.client,
              o = e.picker,
              r = n.props,
              i = r.actionOptions,
              c = r.action,
              a = r.clientOptions.security,
              u = r.file,
              s = r.source;

          switch (c) {
            case "transform":
              return new Promise(function (e, n) {
                try {
                  e(t.transform(s, i));
                } catch (e) {
                  n(e);
                }
              });

            case "retrieve":
              return t.retrieve(s, i, a);

            case "metadata":
              return t.metadata(s, i, a);

            case "storeUrl":
              return t.storeURL(s, i, a);

            case "upload":
              return t.upload(u, i);

            case "remove":
              return t.remove(s, a);

            case "removeMetadata":
              return t.removeMetadata(s, a);

            case "preview":
              return t.preview(s, i);

            case "logout":
              return t.logout(i);

            default:
              return o.open();
          }
        });
        var c = n.props,
            a = c.apikey,
            l = c.clientOptions,
            y = c.actionOptions,
            d = c.action,
            b = c.componentDisplayMode,
            v = o.init(a, l);
        return n.state = {
          client: v,
          picker: "pick" === d ? v.picker(s({}, y, {
            onUploadDone: n.onFinished
          })) : null,
          componentDisplayModeMerged: s({}, {
            type: "button",
            customText: "Pick file",
            customClass: "filestack-react"
          }, b)
        }, n.onFinished = n.onFinished.bind(f(n)), n.onFail = n.onFail.bind(f(n)), n;
      }

      var n, c, a;
      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && y(e, t);
      }(t, r["Component"]), n = t, (c = [{
        key: "componentWillMount",
        value: function value() {
          var e = this.props.customRender;
          "immediate" !== this.state.componentDisplayModeMerged.type || e || this.completeAction().then(this.onFinished).catch(this.onFail);
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          var e = this.props.action,
              t = this.state.picker;
          "pick" === e && t.close();
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props.customRender,
              t = this.state.componentDisplayModeMerged,
              n = t.type,
              o = t.customText,
              r = t.customClass;
          if (e) return i.a.createElement(e, {
            onPick: this.onClickPick
          });
          if ("immediate" === n) return null;
          var c = {
            button: "button",
            link: "a"
          }[n];
          return i.a.createElement(c, {
            name: "filestack",
            onClick: this.onClickPick,
            className: r
          }, o);
        }
      }]) && l(n.prototype, c), a && l(n, a), t;
    }();

    m(d, "defaultProps", {
      action: "pick",
      componentDisplayMode: {
        type: "button",
        customText: "Pick file",
        customClass: "filestack-react"
      },
      actionOptions: {},
      onSuccess: function onSuccess(e) {
        return console.log(e);
      },
      onError: function onError(e) {
        return console.error(e);
      },
      clientOptions: {},
      file: null,
      source: null,
      customRender: null
    }), m(d, "propTypes", {
      apikey: a.a.string.isRequired,
      action: a.a.oneOf(["transform", "retrieve", "metadata", "storeUrl", "upload", "remove", "pick", "removeMetadata", "preview", "logout"]),
      componentDisplayMode: a.a.objectOf(a.a.any),
      actionOptions: a.a.objectOf(a.a.any),
      onSuccess: a.a.func,
      onError: a.a.func,
      clientOptions: a.a.shape({
        cname: a.a.string,
        security: a.a.objectOf(a.a.any),
        sessionCache: a.a.bool
      }),
      file: a.a.objectOf(a.a.any),
      source: a.a.string,
      customRender: a.a.func
    });
    var b = d;
    n.d(t, "client", function () {
      return o;
    });
    t.default = b;
  }]);
});